<script lang="ts">
    import { navstore, generalInfo } from "../store"

    import Navigation from "./Navigation.svelte"

    let navopen = false

    let year = new Date().getFullYear()

    if (typeof document !== "undefined") {
        ;(function (a, b, c, d) {
            a = "https://tags.tiqcdn.com/utag/bahnx/b-infrastructure/prod/utag.js"
            b = document
            c = "script"
            d = b.createElement(c)
            d.src = a
            d.type = "text/java" + c
            d.async = true
            a = b.getElementsByTagName(c)[0]
            a.parentNode.insertBefore(d, a)
        })()
    }
</script>

<footer>
    <div class="wrapper">
        <section id="foerderung">
            <h3>{$generalInfo?.partner || ""}</h3>
            <div class="logos">
                <div class="logo">
                    <img src="/assets/img/de_kofinanziert_von_der_europaischen_union_pos.svg" />
                </div>
                <div class="logo">
                    <img src="/assets/img/DB_VDE8_Signet1_RGB.svg" />
                </div>
                <div class="logo">
                    <img src="/assets/img/BMDV_2021_Logo.svg" />
                </div>
            </div>
        </section>
    </div>
    <div class="gray-bg">
        <div class="wrapper">
            <div class="row social-row">
                <h3>{$generalInfo?.socials || "Folgen Sie uns auf unserem YouTube-Kanal"}</h3>
                <div class="grow">
                    <nav class="social">
                        {#if $navstore[2]}
                            <Navigation data="{$navstore[2]}" level="{1}" depth="{3}" bind:navopen="{navopen}" />
                        {/if}
                    </nav>
                </div>
            </div>
            <div class="row border-top">
                <div class="row">
                    <nav class="footer-nav grow">
                        {#if $navstore[1]}
                            <Navigation data="{$navstore[1]}" level="{1}" depth="{3}" bind:navopen="{navopen}" />
                        {/if}
                    </nav>
                    <div class="copy">
                        © {year} DB InfraGO AG |
                        <button type="button" onclick="window.DB_CMP.showSecondLayer()">Analyse verwalten</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
